// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import { generateSecurityAnalysisLegendSubtext } from '../../utils/securityAnalysis';
import ColorLegend from '../common/ColorLegend';
import securityDashboardColors from '../../constants/securityDashboardColors';
import SecurityDashboardsOverviewCategory from './SecurityDashboardsOverviewCategory';
// css
import '../../styles/components/analytics/SecurityDashboardsOverview.scss';


class SecurityDashboardsOverview extends Component {

  renderCategories() {
    const { categories } = this.props;
    const chunks = [
      [categories[0]],
      [categories[1]],
      [categories[2], categories[3], categories[4], categories[5]]
    ].map(chunk => compact(chunk));

    return chunks.map((chunk, index) => (
      <div
        key={index}
        className='col-md-4'>
        {chunk.map(category => (
          <SecurityDashboardsOverviewCategory
            key={category.title}
            category={category}
          />
        ))}
      </div>
    ));
  }

  render() {
    const {
      enabledDashboardCount,
      totalDashboardCount
    } = this.props;

    return (
      <div className='analytics__security-dashboards-overview' id='pptx_security_dashboards_overview' >
        <h2>Security Recommendation: Dashboards Overview</h2>
        <div className='box'>
          <h3>
            {enabledDashboardCount} of {totalDashboardCount}
            &nbsp;Enterprise Security Dashboards are currently possible with your indexing levels:
          </h3>
          <div className='row'>
            {this.renderCategories()}
          </div>
          <ColorLegend
            items={[
              {
                color: securityDashboardColors.acceptable,
                label: 'Adequately Indexed Dashboards',
                subtext: generateSecurityAnalysisLegendSubtext('acceptable')
              },
              {
                color: securityDashboardColors.rudimentary,
                label: 'Minimally Indexed Dashboards',
                subtext: generateSecurityAnalysisLegendSubtext('rudimentary')
              },
              {
                color: securityDashboardColors.inadequate,
                label: 'Under-Indexed Dashboards',
                subtext: generateSecurityAnalysisLegendSubtext('inadequate')
              }
            ]}
          />
        </div>
      </div>
    );
  }
}

SecurityDashboardsOverview.propTypes = {
  categories: PropTypes.array.isRequired,
  enabledDashboardCount: PropTypes.number.isRequired,
  totalDashboardCount: PropTypes.number.isRequired
};

export default SecurityDashboardsOverview;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDashboardsOverview.js